import { Box } from "@mui/material"
import { Task } from "@mui/icons-material"

import { TopToolbar, useGetIdentity, useGetOne, useRecordContext } from 'react-admin'
import { InvoiceReadModel, UserReadModel } from '../GeneratedClients/FreeBillApi'
import DownloadPdfButton from './actionButtons/DownloadPdfButton'
import CancelInvoiceDialog from './actionDialogs/CancelInvoiceDialog'
import CreateBookingTransactionDialog from './actionDialogs/CreateBookingTransactionDialog'
import AuditTrailDrawer from './actionDialogs/AuditTrailDrawer'
import SendInvoiceButton from './actionButtons/SendInvoiceButton'
import BreadCrumbs from "../invoiceCorrelations/BreadCrumbs"

const InvoiceShowActions = () => {

  const { data: identity, isLoading: identityLoading } = useGetIdentity()
  //@ts-ignore
  const { data: user, isLoading: userLoading} = useGetOne<UserReadModel>("users", {id: identity?.id}, {enabled: !identityLoading})
  const invoice = useRecordContext<InvoiceReadModel>()
  if(!invoice || identityLoading || userLoading) return null
  const invoiceId = invoice.id!.toString()

  return (
    <TopToolbar>
      <Box display={"flex"} justifyContent={"space-between"} width={"100%"}>
        <Box pt={0.5}>
          <BreadCrumbs 
            links={[
              {
                title: invoice?.textModel?.heading, 
                href: `/#/invoices/${invoice.id}/show`,
                icon: <Task sx={{ mr: 0.5 }} fontSize="inherit" />
              }
            ]}
          />
        </Box>
        <Box>
          <AuditTrailDrawer />
          <CreateBookingTransactionDialog invoice={invoice} />
          <DownloadPdfButton />
          <SendInvoiceButton user={user} />
          <CancelInvoiceDialog invoiceId={invoiceId} invoice={invoice} userId={user?.id!} />
        </Box>
      </Box>
    </TopToolbar>
  )
}

export default InvoiceShowActions